import React from "react";
import DashboardPanelHeader from "components/DashboardPanelHeader";
import { Box, Typography, LinearProgress, CircularProgress } from "@mui/material";

const AverageTimeToDealChart = ({ data, isLoading, isError }) => {
  const avgDays = Math.round(data?.averageTimeToDealDays ?? 0);

  const maxDays = 100;

  const progress = (avgDays / maxDays) * 100;


  return (
    <Box
      sx={{
        background: "#fff",
        border: "1px solid #E4E4E4",
        borderRadius: 1,
        width: "100%",
        height: "100%"
      }}
    >
      <DashboardPanelHeader eyebrow="Deal velocity" title="Average Conversion Time" subtitle="Measure the typical time required to convert a lead into a completed deal." />
      <Box
        sx={{
          borderBottom: "1px solid #E4E4E4",
          p: 1.5,
          display: "none",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Outfit",
            fontWeight: 600,
            fontSize: "20px",
          }}
        >
          Average Time to Deal (Days)
        </Typography>

        <Typography
          sx={{
            fontFamily: "Outfit",
            fontWeight: 300,
            fontSize: "14px",
            color: "#7D7F81",
          }}
        >
          Average duration taken to convert leads into deals
        </Typography>
      </Box>
      {isLoading && (
        <Box
          sx={{
            minHeight: "100px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress size={32} />
        </Box>
      )}
      {isError && (
        <Box
          sx={{
            minHeight: "100px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 2,
          }}
        >
          <Typography
            sx={{
              fontFamily: "Outfit, sans-serif",
              fontSize: "14px",
              color: "#FF4F8B",
              textAlign: "center",
            }}
          >
            Failed to load data. Please try again.
          </Typography>
        </Box>
      )}
      {!isError && !isLoading && <Box sx={{ p: 3 }}>
        <Typography
          sx={{
            fontFamily: "Outfit",
            fontWeight: 600,
            mb: 1,
          }}
        >
          {avgDays} Days
        </Typography>

        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: 10,
            borderRadius: 5,
            backgroundColor: "#E5E7EB",
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#3B82F6",
            },
          }}
        />
      </Box>}
    </Box>
  );
};

export default AverageTimeToDealChart;
